import { render, staticRenderFns } from "./account-created.vue?vue&type=template&id=26c7f284"
import script from "./account-created.js?vue&type=script&lang=js&external"
export * from "./account-created.js?vue&type=script&lang=js&external"
import style0 from "./account-created.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports